module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-richtext-fill-769e0fb5.svg";